import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahcontact',
  templateUrl: './asahcontact.component.html',
  styleUrls: ['./asahcontact.component.scss']
})
export class AsahcontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
